import React from 'react';
import { Skeleton } from '@mui/material';
import { Divider, Typography, Box, Tabs, Tab } from '@mui/material';
import Grid from '@mui/material/Grid2';
import ChildCard from "../../../shared/ChildCard";

const MyReservationsOverviewSkeleton = () => (
    <>
        <Grid container sx={{ mb: 4 }}>
            <Grid container size={12} direction="column" alignItems="flex-start" spacing={2} mb={3}>
                <Skeleton variant="text" width={100} height={40} />
            </Grid>
            <Grid container size={{ xs: 12, sm: 6 }} direction="column" alignItems="flex-start" spacing={2}>
                <Grid container direction="column" item spacing={2}>
                    <Grid item>
                        <Skeleton variant="text" width={150} height={20} />
                    </Grid>
                    <Grid item>
                        <Skeleton variant="text" width={200} height={20} />
                    </Grid>
                    <Grid item>
                        <Skeleton variant="text" width={150} height={20} />
                    </Grid>
                    <Grid item>
                        <Skeleton variant="text" width={120} height={20} />
                    </Grid>
                </Grid>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }} container direction="column" alignItems="flex-end">
                <Grid item>
                    <Skeleton variant="text" width={150} height={20} />
                </Grid>
                <Grid item>
                    <Skeleton variant="text" width={200} height={20} />
                </Grid>
            </Grid>
        </Grid>

        <Divider sx={{ my: 3 }} />

        <Typography variant="body1" fontWeight="bold" mb={2}><Skeleton variant="text" width={100} height={20} /></Typography>
        <Grid container spacing={3} mb={3}>
            {[...Array(4)].map((_, index) => (
                <Grid item xs={12} sm={2} key={index}>
                    <Skeleton variant="text" width={200} height={20} />
                    <Skeleton variant="text" width={200} height={20} />
                </Grid>
            ))}
        </Grid>

        <Divider sx={{ mb: 3 }} />

    
        <Grid size={12} display="flex" alignItems="stretch" sx={{ height: '100%' }}>
            <Skeleton variant="rectangular" height={200} width={1200} />
        </Grid>


        <Grid item xs={12} mt={5}>
            <Skeleton width={120} height={40} variant="rectangular" />
        </Grid>
    </>
);

export default MyReservationsOverviewSkeleton;